import React from 'react';
import { FlaskConicalIcon } from 'lucide-react';

/**
 * SandboxBanner — sticky yellow banner that appears at the top of the
 * dashboard when the current user has toggled `sandbox_mode` on. It is a
 * pure visual indicator (no behavior changes) so the user knows they are
 * actively in a test/experimentation session. Toggle lives in
 * Settings → "Sandbox Modu".
 */
const SandboxBanner = ({ user }) => {
  if (!user?.sandbox_mode) return null;
  return (
    <div
      role="alert"
      className="bg-amber-100 border-b-2 border-amber-400 text-amber-900 px-4 py-2.5 flex items-center justify-center gap-2 text-sm font-medium"
      data-testid="sandbox-banner"
    >
      <FlaskConicalIcon className="w-4 h-4 flex-shrink-0" />
      <span>
        🧪 <strong>SANDBOX MODU AÇIK</strong> — bu oturumdaki işlemler test amaçlıdır.
        Ayarlar &rarr; Sandbox Modu&apos;ndan kapatabilirsin.
      </span>
    </div>
  );
};

export default SandboxBanner;
